import { render, staticRenderFns } from "./greece.vue?vue&type=template&id=96bfd9a2&"
import script from "./greece.vue?vue&type=script&lang=js&"
export * from "./greece.vue?vue&type=script&lang=js&"
import style0 from "./greece.vue?vue&type=style&index=0&id=96bfd9a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports